// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file issues/v1/repo_issues_dashboard.proto (package github.issues.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { SafeHtml } from "../../common/v1/safe_html_pb";
import { file_common_v1_safe_html } from "../../common/v1/safe_html_pb";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file issues/v1/repo_issues_dashboard.proto.
 */
export const file_issues_v1_repo_issues_dashboard: GenFile = /*@__PURE__*/
  fileDesc("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", [file_common_v1_safe_html, file_google_protobuf_wrappers]);

/**
 * Initial mixed issue and pull-request results required to render GET /:owner/:repo/issues.
 *
 * @generated from message github.issues.v1.RepoIssuesDashboardContentResponse
 */
export type RepoIssuesDashboardContentResponse = Message<"github.issues.v1.RepoIssuesDashboardContentResponse"> & {
  /**
   * @generated from field: repeated github.issues.v1.RepoIssuesDashboardResult results = 1;
   */
  results: RepoIssuesDashboardResult[];

  /**
   * @generated from field: github.issues.v1.RepoIssuesDashboardPageInfo page_info = 2;
   */
  pageInfo?: RepoIssuesDashboardPageInfo;

  /**
   * @generated from field: google.protobuf.StringValue error = 3;
   */
  error?: string;
};

/**
 * Describes the message github.issues.v1.RepoIssuesDashboardContentResponse.
 * Use `create(RepoIssuesDashboardContentResponseSchema)` to create a new message.
 */
export const RepoIssuesDashboardContentResponseSchema: GenMessage<RepoIssuesDashboardContentResponse> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 0);

/**
 * Stable layout data shared by repository Issues routes.
 *
 * @generated from message github.issues.v1.RepoIssuesDashboardLayoutResponse
 */
export type RepoIssuesDashboardLayoutResponse = Message<"github.issues.v1.RepoIssuesDashboardLayoutResponse"> & {
  /**
   * @generated from field: bool has_projects_enabled = 1;
   */
  hasProjectsEnabled: boolean;

  /**
   * @generated from field: bool has_labels_archiving_enabled = 2;
   */
  hasLabelsArchivingEnabled: boolean;

  /**
   * @generated from field: github.issues.v1.RepoIssuesDashboardCurrentUser current_user = 3;
   */
  currentUser?: RepoIssuesDashboardCurrentUser;

  /**
   * @generated from field: github.issues.v1.RepoIssuesDashboardCurrentUserSettings current_user_settings = 4;
   */
  currentUserSettings?: RepoIssuesDashboardCurrentUserSettings;

  /**
   * @generated from field: google.protobuf.BoolValue sidebar_expanded = 5;
   */
  sidebarExpanded?: boolean;

  /**
   * @generated from field: repeated github.issues.v1.RepoIssuesDashboardPinnedView pinned_views = 6;
   */
  pinnedViews: RepoIssuesDashboardPinnedView[];

  /**
   * @generated from field: bool pinned_views_enabled = 7;
   */
  pinnedViewsEnabled: boolean;

  /**
   * @generated from field: bool best_match_sort_enabled = 8;
   */
  bestMatchSortEnabled: boolean;

  /**
   * @generated from field: bool issue_types_enabled = 9;
   */
  issueTypesEnabled: boolean;

  /**
   * @generated from field: google.protobuf.StringValue issue_search_type = 10;
   */
  issueSearchType?: string;

  /**
   * @generated from field: bool show_issue_field_pills = 11;
   */
  showIssueFieldPills: boolean;

  /**
   * @generated from field: bool viewer_can_create_issues = 12;
   */
  viewerCanCreateIssues: boolean;

  /**
   * @generated from field: bool is_writable = 13;
   */
  isWritable: boolean;

  /**
   * @generated from field: github.issues.v1.RepoIssuesDashboardActions actions = 14;
   */
  actions?: RepoIssuesDashboardActions;
};

/**
 * Describes the message github.issues.v1.RepoIssuesDashboardLayoutResponse.
 * Use `create(RepoIssuesDashboardLayoutResponseSchema)` to create a new message.
 */
export const RepoIssuesDashboardLayoutResponseSchema: GenMessage<RepoIssuesDashboardLayoutResponse> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 1);

/**
 * @generated from message github.issues.v1.RepoIssuesDashboardCurrentUser
 */
export type RepoIssuesDashboardCurrentUser = Message<"github.issues.v1.RepoIssuesDashboardCurrentUser"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string login = 2;
   */
  login: string;

  /**
   * @generated from field: google.protobuf.StringValue name = 3;
   */
  name?: string;

  /**
   * @generated from field: string avatar_url = 4;
   */
  avatarUrl: string;

  /**
   * @generated from field: bool is_emu = 5;
   */
  isEmu: boolean;
};

/**
 * Describes the message github.issues.v1.RepoIssuesDashboardCurrentUser.
 * Use `create(RepoIssuesDashboardCurrentUserSchema)` to create a new message.
 */
export const RepoIssuesDashboardCurrentUserSchema: GenMessage<RepoIssuesDashboardCurrentUser> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 2);

/**
 * @generated from message github.issues.v1.RepoIssuesDashboardCurrentUserSettings
 */
export type RepoIssuesDashboardCurrentUserSettings = Message<"github.issues.v1.RepoIssuesDashboardCurrentUserSettings"> & {
  /**
   * @generated from field: google.protobuf.Int32Value preferred_emoji_skin_tone = 1;
   */
  preferredEmojiSkinTone?: number;

  /**
   * @generated from field: bool copilot_show_functionality = 2;
   */
  copilotShowFunctionality: boolean;
};

/**
 * Describes the message github.issues.v1.RepoIssuesDashboardCurrentUserSettings.
 * Use `create(RepoIssuesDashboardCurrentUserSettingsSchema)` to create a new message.
 */
export const RepoIssuesDashboardCurrentUserSettingsSchema: GenMessage<RepoIssuesDashboardCurrentUserSettings> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 3);

/**
 * @generated from message github.issues.v1.RepoIssuesDashboardPinnedView
 */
export type RepoIssuesDashboardPinnedView = Message<"github.issues.v1.RepoIssuesDashboardPinnedView"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string icon = 3;
   */
  icon: string;

  /**
   * @generated from field: string color = 4;
   */
  color: string;

  /**
   * @generated from field: string visibility = 5;
   */
  visibility: string;
};

/**
 * Describes the message github.issues.v1.RepoIssuesDashboardPinnedView.
 * Use `create(RepoIssuesDashboardPinnedViewSchema)` to create a new message.
 */
export const RepoIssuesDashboardPinnedViewSchema: GenMessage<RepoIssuesDashboardPinnedView> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 4);

/**
 * @generated from message github.issues.v1.RepoIssuesDashboardActions
 */
export type RepoIssuesDashboardActions = Message<"github.issues.v1.RepoIssuesDashboardActions"> & {
  /**
   * @generated from field: github.issues.v1.RepoIssuesDashboardLink labels = 1 [deprecated = true];
   * @deprecated
   */
  labels?: RepoIssuesDashboardLink;

  /**
   * @generated from field: github.issues.v1.RepoIssuesDashboardLink milestones = 2 [deprecated = true];
   * @deprecated
   */
  milestones?: RepoIssuesDashboardLink;

  /**
   * @generated from field: github.issues.v1.RepoIssuesDashboardPrimaryAction new_issue = 3;
   */
  newIssue?: RepoIssuesDashboardPrimaryAction;
};

/**
 * Describes the message github.issues.v1.RepoIssuesDashboardActions.
 * Use `create(RepoIssuesDashboardActionsSchema)` to create a new message.
 */
export const RepoIssuesDashboardActionsSchema: GenMessage<RepoIssuesDashboardActions> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 5);

/**
 * @generated from message github.issues.v1.RepoIssuesDashboardLink
 */
export type RepoIssuesDashboardLink = Message<"github.issues.v1.RepoIssuesDashboardLink"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;
};

/**
 * Describes the message github.issues.v1.RepoIssuesDashboardLink.
 * Use `create(RepoIssuesDashboardLinkSchema)` to create a new message.
 */
export const RepoIssuesDashboardLinkSchema: GenMessage<RepoIssuesDashboardLink> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 6);

/**
 * @generated from message github.issues.v1.RepoIssuesDashboardPrimaryAction
 */
export type RepoIssuesDashboardPrimaryAction = Message<"github.issues.v1.RepoIssuesDashboardPrimaryAction"> & {
  /**
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * @generated from field: google.protobuf.StringValue url = 2;
   */
  url?: string;

  /**
   * @generated from field: google.protobuf.StringValue disabled_reason = 3;
   */
  disabledReason?: string;
};

/**
 * Describes the message github.issues.v1.RepoIssuesDashboardPrimaryAction.
 * Use `create(RepoIssuesDashboardPrimaryActionSchema)` to create a new message.
 */
export const RepoIssuesDashboardPrimaryActionSchema: GenMessage<RepoIssuesDashboardPrimaryAction> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 7);

/**
 * Owner-scoped Planning response. Rows and pagination intentionally share the
 * repository Issues contract so global node IDs remain the sole row identity.
 *
 * @generated from message github.issues.v1.PlanningIssuesContentResponse
 */
export type PlanningIssuesContentResponse = Message<"github.issues.v1.PlanningIssuesContentResponse"> & {
  /**
   * @generated from field: repeated github.issues.v1.RepoIssuesDashboardResult results = 1;
   */
  results: RepoIssuesDashboardResult[];

  /**
   * @generated from field: github.issues.v1.RepoIssuesDashboardPageInfo page_info = 2;
   */
  pageInfo?: RepoIssuesDashboardPageInfo;

  /**
   * @generated from field: google.protobuf.StringValue error = 3;
   */
  error?: string;
};

/**
 * Describes the message github.issues.v1.PlanningIssuesContentResponse.
 * Use `create(PlanningIssuesContentResponseSchema)` to create a new message.
 */
export const PlanningIssuesContentResponseSchema: GenMessage<PlanningIssuesContentResponse> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 8);

/**
 * @generated from message github.issues.v1.RepoIssuesDashboardPageInfo
 */
export type RepoIssuesDashboardPageInfo = Message<"github.issues.v1.RepoIssuesDashboardPageInfo"> & {
  /**
   * @generated from field: int32 current_page = 1;
   */
  currentPage: number;

  /**
   * @generated from field: int32 total_pages = 2;
   */
  totalPages: number;

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;

  /**
   * @generated from field: google.protobuf.Int32Value open_count = 4;
   */
  openCount?: number;

  /**
   * @generated from field: google.protobuf.Int32Value closed_count = 5;
   */
  closedCount?: number;
};

/**
 * Describes the message github.issues.v1.RepoIssuesDashboardPageInfo.
 * Use `create(RepoIssuesDashboardPageInfoSchema)` to create a new message.
 */
export const RepoIssuesDashboardPageInfoSchema: GenMessage<RepoIssuesDashboardPageInfo> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 9);

/**
 * The global node ID is the canonical identity for either row type.
 *
 * @generated from message github.issues.v1.RepoIssuesDashboardResult
 */
export type RepoIssuesDashboardResult = Message<"github.issues.v1.RepoIssuesDashboardResult"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: github.issues.v1.RepoIssuesDashboardItemType item_type = 2;
   */
  itemType: RepoIssuesDashboardItemType;

  /**
   * @generated from oneof github.issues.v1.RepoIssuesDashboardResult.item
   */
  item: {
    /**
     * @generated from field: github.issues.v1.RepoIssue issue = 3;
     */
    value: RepoIssue;
    case: "issue";
  } | {
    /**
     * @generated from field: github.issues.v1.RepoIssuePullRequest pull_request = 4;
     */
    value: RepoIssuePullRequest;
    case: "pullRequest";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message github.issues.v1.RepoIssuesDashboardResult.
 * Use `create(RepoIssuesDashboardResultSchema)` to create a new message.
 */
export const RepoIssuesDashboardResultSchema: GenMessage<RepoIssuesDashboardResult> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 10);

/**
 * @generated from message github.issues.v1.RepoIssue
 */
export type RepoIssue = Message<"github.issues.v1.RepoIssue"> & {
  /**
   * @generated from field: int32 number = 1;
   */
  number: number;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: github.common.v1.SafeHtml title_html = 3;
   */
  titleHtml?: SafeHtml;

  /**
   * @generated from field: github.issues.v1.RepoIssueState state = 4;
   */
  state: RepoIssueState;

  /**
   * @generated from field: github.issues.v1.RepoIssueStateReason state_reason = 5;
   */
  stateReason: RepoIssueStateReason;

  /**
   * @generated from field: bool closed = 6;
   */
  closed: boolean;

  /**
   * @generated from field: google.protobuf.StringValue closed_at = 7;
   */
  closedAt?: string;

  /**
   * @generated from field: string created_at = 8;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 9;
   */
  updatedAt: string;

  /**
   * @generated from field: int32 comment_count = 10;
   */
  commentCount: number;

  /**
   * @generated from field: google.protobuf.StringValue permalink = 11;
   */
  permalink?: string;

  /**
   * @generated from field: google.protobuf.StringValue repo_name_with_owner = 12;
   */
  repoNameWithOwner?: string;

  /**
   * @generated from field: repeated github.issues.v1.RepoIssuesDashboardLabel labels = 13;
   */
  labels: RepoIssuesDashboardLabel[];

  /**
   * @generated from field: repeated github.issues.v1.RepoIssueAssignee assignees = 14;
   */
  assignees: RepoIssueAssignee[];

  /**
   * @generated from field: github.issues.v1.RepoIssueAuthor author = 15;
   */
  author?: RepoIssueAuthor;

  /**
   * @generated from field: github.issues.v1.RepoIssueType issue_type = 16;
   */
  issueType?: RepoIssueType;

  /**
   * @generated from field: github.issues.v1.RepoIssueMilestone milestone = 17;
   */
  milestone?: RepoIssueMilestone;

  /**
   * @generated from field: repeated github.issues.v1.RepoIssueFieldValue issue_field_values = 18;
   */
  issueFieldValues: RepoIssueFieldValue[];

  /**
   * @generated from field: google.protobuf.StringValue alive_channel = 19;
   */
  aliveChannel?: string;
};

/**
 * Describes the message github.issues.v1.RepoIssue.
 * Use `create(RepoIssueSchema)` to create a new message.
 */
export const RepoIssueSchema: GenMessage<RepoIssue> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 11);

/**
 * @generated from message github.issues.v1.RepoIssuePullRequest
 */
export type RepoIssuePullRequest = Message<"github.issues.v1.RepoIssuePullRequest"> & {
  /**
   * @generated from field: int32 number = 1;
   */
  number: number;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: github.common.v1.SafeHtml title_html = 3;
   */
  titleHtml?: SafeHtml;

  /**
   * @generated from field: github.issues.v1.RepoIssuePullRequestState state = 4;
   */
  state: RepoIssuePullRequestState;

  /**
   * @generated from field: github.issues.v1.RepoIssuePullRequestDisplayState display_state = 5;
   */
  displayState: RepoIssuePullRequestDisplayState;

  /**
   * @generated from field: bool is_draft = 6;
   */
  isDraft: boolean;

  /**
   * @generated from field: bool is_read_by_current_user = 7;
   */
  isReadByCurrentUser: boolean;

  /**
   * @generated from field: google.protobuf.StringValue permalink = 8;
   */
  permalink?: string;

  /**
   * @generated from field: google.protobuf.StringValue repo_name_with_owner = 9;
   */
  repoNameWithOwner?: string;

  /**
   * @generated from field: repeated github.issues.v1.RepoIssuesDashboardLabel labels = 10;
   */
  labels: RepoIssuesDashboardLabel[];

  /**
   * @generated from field: repeated github.issues.v1.RepoIssuePullRequestAssignee assignees = 11;
   */
  assignees: RepoIssuePullRequestAssignee[];

  /**
   * @generated from field: github.issues.v1.RepoIssuePullRequestAuthor author = 12;
   */
  author?: RepoIssuePullRequestAuthor;

  /**
   * @generated from field: github.issues.v1.RepoIssuePullRequestAgentAttributedUser agent_attributed_user = 13;
   */
  agentAttributedUser?: RepoIssuePullRequestAgentAttributedUser;

  /**
   * @generated from field: int32 comment_count = 14;
   */
  commentCount: number;

  /**
   * @generated from field: google.protobuf.StringValue commit_head_sha_channel = 15;
   */
  commitHeadShaChannel?: string;

  /**
   * @generated from field: string created_at = 16;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 17;
   */
  updatedAt: string;

  /**
   * @generated from field: google.protobuf.StringValue head_sha = 18;
   */
  headSha?: string;

  /**
   * @generated from field: google.protobuf.Int32Value stack_position = 19;
   */
  stackPosition?: number;

  /**
   * @generated from field: google.protobuf.Int32Value stack_size = 20;
   */
  stackSize?: number;

  /**
   * @generated from field: google.protobuf.StringValue alive_channel = 21;
   */
  aliveChannel?: string;
};

/**
 * Describes the message github.issues.v1.RepoIssuePullRequest.
 * Use `create(RepoIssuePullRequestSchema)` to create a new message.
 */
export const RepoIssuePullRequestSchema: GenMessage<RepoIssuePullRequest> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 12);

/**
 * @generated from message github.issues.v1.RepoIssuesDashboardLabel
 */
export type RepoIssuesDashboardLabel = Message<"github.issues.v1.RepoIssuesDashboardLabel"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.StringValue color = 3;
   */
  color?: string;

  /**
   * @generated from field: google.protobuf.StringValue description = 4;
   */
  description?: string;

  /**
   * @generated from field: github.common.v1.SafeHtml name_html = 5;
   */
  nameHtml?: SafeHtml;
};

/**
 * Describes the message github.issues.v1.RepoIssuesDashboardLabel.
 * Use `create(RepoIssuesDashboardLabelSchema)` to create a new message.
 */
export const RepoIssuesDashboardLabelSchema: GenMessage<RepoIssuesDashboardLabel> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 13);

/**
 * @generated from message github.issues.v1.RepoIssueAssignee
 */
export type RepoIssueAssignee = Message<"github.issues.v1.RepoIssueAssignee"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string login = 2;
   */
  login: string;

  /**
   * @generated from field: google.protobuf.StringValue name = 3;
   */
  name?: string;

  /**
   * @generated from field: string avatar_url = 4;
   */
  avatarUrl: string;

  /**
   * @generated from field: string profile_resource_path = 5;
   */
  profileResourcePath: string;

  /**
   * @generated from field: bool is_copilot = 6;
   */
  isCopilot: boolean;

  /**
   * @generated from field: bool is_agent = 7;
   */
  isAgent: boolean;
};

/**
 * Describes the message github.issues.v1.RepoIssueAssignee.
 * Use `create(RepoIssueAssigneeSchema)` to create a new message.
 */
export const RepoIssueAssigneeSchema: GenMessage<RepoIssueAssignee> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 14);

/**
 * @generated from message github.issues.v1.RepoIssueAuthor
 */
export type RepoIssueAuthor = Message<"github.issues.v1.RepoIssueAuthor"> & {
  /**
   * @generated from field: string login = 1;
   */
  login: string;

  /**
   * @generated from field: google.protobuf.StringValue name = 2;
   */
  name?: string;

  /**
   * @generated from field: string avatar_url = 3;
   */
  avatarUrl: string;

  /**
   * @generated from field: string resource_path = 4;
   */
  resourcePath: string;

  /**
   * @generated from field: string typename = 5;
   */
  typename: string;

  /**
   * @generated from field: bool is_copilot = 6;
   */
  isCopilot: boolean;

  /**
   * @generated from field: bool is_agent = 7;
   */
  isAgent: boolean;
};

/**
 * Describes the message github.issues.v1.RepoIssueAuthor.
 * Use `create(RepoIssueAuthorSchema)` to create a new message.
 */
export const RepoIssueAuthorSchema: GenMessage<RepoIssueAuthor> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 15);

/**
 * @generated from message github.issues.v1.RepoIssueType
 */
export type RepoIssueType = Message<"github.issues.v1.RepoIssueType"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string color = 2;
   */
  color: string;
};

/**
 * Describes the message github.issues.v1.RepoIssueType.
 * Use `create(RepoIssueTypeSchema)` to create a new message.
 */
export const RepoIssueTypeSchema: GenMessage<RepoIssueType> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 16);

/**
 * @generated from message github.issues.v1.RepoIssueMilestone
 */
export type RepoIssueMilestone = Message<"github.issues.v1.RepoIssueMilestone"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;
};

/**
 * Describes the message github.issues.v1.RepoIssueMilestone.
 * Use `create(RepoIssueMilestoneSchema)` to create a new message.
 */
export const RepoIssueMilestoneSchema: GenMessage<RepoIssueMilestone> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 17);

/**
 * @generated from message github.issues.v1.RepoIssueFieldValue
 */
export type RepoIssueFieldValue = Message<"github.issues.v1.RepoIssueFieldValue"> & {
  /**
   * @generated from field: string field_name = 1;
   */
  fieldName: string;

  /**
   * @generated from field: string data_type = 2;
   */
  dataType: string;

  /**
   * @generated from field: google.protobuf.StringValue value = 3;
   */
  value?: string;

  /**
   * @generated from field: google.protobuf.DoubleValue number_value = 4;
   */
  numberValue?: number;

  /**
   * @generated from field: repeated string options = 5;
   */
  options: string[];
};

/**
 * Describes the message github.issues.v1.RepoIssueFieldValue.
 * Use `create(RepoIssueFieldValueSchema)` to create a new message.
 */
export const RepoIssueFieldValueSchema: GenMessage<RepoIssueFieldValue> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 18);

/**
 * @generated from message github.issues.v1.RepoIssuePullRequestAssignee
 */
export type RepoIssuePullRequestAssignee = Message<"github.issues.v1.RepoIssuePullRequestAssignee"> & {
  /**
   * @generated from field: string login = 1;
   */
  login: string;

  /**
   * @generated from field: string avatar_url = 2;
   */
  avatarUrl: string;
};

/**
 * Describes the message github.issues.v1.RepoIssuePullRequestAssignee.
 * Use `create(RepoIssuePullRequestAssigneeSchema)` to create a new message.
 */
export const RepoIssuePullRequestAssigneeSchema: GenMessage<RepoIssuePullRequestAssignee> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 19);

/**
 * @generated from message github.issues.v1.RepoIssuePullRequestAuthor
 */
export type RepoIssuePullRequestAuthor = Message<"github.issues.v1.RepoIssuePullRequestAuthor"> & {
  /**
   * @generated from field: string display_login = 1;
   */
  displayLogin: string;
};

/**
 * Describes the message github.issues.v1.RepoIssuePullRequestAuthor.
 * Use `create(RepoIssuePullRequestAuthorSchema)` to create a new message.
 */
export const RepoIssuePullRequestAuthorSchema: GenMessage<RepoIssuePullRequestAuthor> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 20);

/**
 * @generated from message github.issues.v1.RepoIssuePullRequestAgentAttributedUser
 */
export type RepoIssuePullRequestAgentAttributedUser = Message<"github.issues.v1.RepoIssuePullRequestAgentAttributedUser"> & {
  /**
   * @generated from field: string display_login = 1;
   */
  displayLogin: string;
};

/**
 * Describes the message github.issues.v1.RepoIssuePullRequestAgentAttributedUser.
 * Use `create(RepoIssuePullRequestAgentAttributedUserSchema)` to create a new message.
 */
export const RepoIssuePullRequestAgentAttributedUserSchema: GenMessage<RepoIssuePullRequestAgentAttributedUser> = /*@__PURE__*/
  messageDesc(file_issues_v1_repo_issues_dashboard, 21);

/**
 * @generated from enum github.issues.v1.RepoIssuesDashboardItemType
 */
export enum RepoIssuesDashboardItemType {
  /**
   * @generated from enum value: REPO_ISSUES_DASHBOARD_ITEM_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REPO_ISSUES_DASHBOARD_ITEM_TYPE_ISSUE = 1;
   */
  ISSUE = 1,

  /**
   * @generated from enum value: REPO_ISSUES_DASHBOARD_ITEM_TYPE_PULL_REQUEST = 2;
   */
  PULL_REQUEST = 2,
}

/**
 * Describes the enum github.issues.v1.RepoIssuesDashboardItemType.
 */
export const RepoIssuesDashboardItemTypeSchema: GenEnum<RepoIssuesDashboardItemType> = /*@__PURE__*/
  enumDesc(file_issues_v1_repo_issues_dashboard, 0);

/**
 * @generated from enum github.issues.v1.RepoIssueState
 */
export enum RepoIssueState {
  /**
   * @generated from enum value: REPO_ISSUE_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REPO_ISSUE_STATE_OPEN = 1;
   */
  OPEN = 1,

  /**
   * @generated from enum value: REPO_ISSUE_STATE_CLOSED = 2;
   */
  CLOSED = 2,
}

/**
 * Describes the enum github.issues.v1.RepoIssueState.
 */
export const RepoIssueStateSchema: GenEnum<RepoIssueState> = /*@__PURE__*/
  enumDesc(file_issues_v1_repo_issues_dashboard, 1);

/**
 * @generated from enum github.issues.v1.RepoIssueStateReason
 */
export enum RepoIssueStateReason {
  /**
   * @generated from enum value: REPO_ISSUE_STATE_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REPO_ISSUE_STATE_REASON_COMPLETED = 1;
   */
  COMPLETED = 1,

  /**
   * @generated from enum value: REPO_ISSUE_STATE_REASON_NOT_PLANNED = 2;
   */
  NOT_PLANNED = 2,

  /**
   * @generated from enum value: REPO_ISSUE_STATE_REASON_REOPENED = 3;
   */
  REOPENED = 3,

  /**
   * @generated from enum value: REPO_ISSUE_STATE_REASON_DUPLICATE = 4;
   */
  DUPLICATE = 4,
}

/**
 * Describes the enum github.issues.v1.RepoIssueStateReason.
 */
export const RepoIssueStateReasonSchema: GenEnum<RepoIssueStateReason> = /*@__PURE__*/
  enumDesc(file_issues_v1_repo_issues_dashboard, 2);

/**
 * @generated from enum github.issues.v1.RepoIssuePullRequestState
 */
export enum RepoIssuePullRequestState {
  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_STATE_OPEN = 1;
   */
  OPEN = 1,

  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_STATE_CLOSED = 2;
   */
  CLOSED = 2,

  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_STATE_MERGED = 3;
   */
  MERGED = 3,
}

/**
 * Describes the enum github.issues.v1.RepoIssuePullRequestState.
 */
export const RepoIssuePullRequestStateSchema: GenEnum<RepoIssuePullRequestState> = /*@__PURE__*/
  enumDesc(file_issues_v1_repo_issues_dashboard, 3);

/**
 * @generated from enum github.issues.v1.RepoIssuePullRequestDisplayState
 */
export enum RepoIssuePullRequestDisplayState {
  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_DISPLAY_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_DISPLAY_STATE_DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_DISPLAY_STATE_OPEN = 2;
   */
  OPEN = 2,

  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_DISPLAY_STATE_CLOSED = 3;
   */
  CLOSED = 3,

  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_DISPLAY_STATE_MERGED = 4;
   */
  MERGED = 4,

  /**
   * @generated from enum value: REPO_ISSUE_PULL_REQUEST_DISPLAY_STATE_QUEUED = 5;
   */
  QUEUED = 5,
}

/**
 * Describes the enum github.issues.v1.RepoIssuePullRequestDisplayState.
 */
export const RepoIssuePullRequestDisplayStateSchema: GenEnum<RepoIssuePullRequestDisplayState> = /*@__PURE__*/
  enumDesc(file_issues_v1_repo_issues_dashboard, 4);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(RepoIssuesDashboardContentResponseSchema, "029fa66c8635")
registerSchemaHash(RepoIssuesDashboardLayoutResponseSchema, "218f1e7dd55d")
registerSchemaHash(RepoIssuesDashboardCurrentUserSchema, "f2647f96083f")
registerSchemaHash(RepoIssuesDashboardCurrentUserSettingsSchema, "d28131d71e9e")
registerSchemaHash(RepoIssuesDashboardPinnedViewSchema, "4d0fbdb8639e")
registerSchemaHash(RepoIssuesDashboardActionsSchema, "d5c1bbf1bc30")
registerSchemaHash(RepoIssuesDashboardLinkSchema, "d732382b8d14")
registerSchemaHash(RepoIssuesDashboardPrimaryActionSchema, "c80e742f4b2d")
registerSchemaHash(PlanningIssuesContentResponseSchema, "50b8cebfd5bf")
registerSchemaHash(RepoIssuesDashboardPageInfoSchema, "9849ca715386")
registerSchemaHash(RepoIssuesDashboardResultSchema, "b94a37830524")
registerSchemaHash(RepoIssueSchema, "80ef93c7296d")
registerSchemaHash(RepoIssuePullRequestSchema, "ef062a0c0afc")
registerSchemaHash(RepoIssuesDashboardLabelSchema, "8e4e7c5fa4cd")
registerSchemaHash(RepoIssueAssigneeSchema, "a7f0485decc6")
registerSchemaHash(RepoIssueAuthorSchema, "8648b88e598f")
registerSchemaHash(RepoIssueTypeSchema, "5dcfb825c794")
registerSchemaHash(RepoIssueMilestoneSchema, "c4ca50ac87cc")
registerSchemaHash(RepoIssueFieldValueSchema, "83356fae6d5c")
registerSchemaHash(RepoIssuePullRequestAssigneeSchema, "1b1628d722d4")
registerSchemaHash(RepoIssuePullRequestAuthorSchema, "7b12d297e5d2")
registerSchemaHash(RepoIssuePullRequestAgentAttributedUserSchema, "52bcaf5534d5")
